import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../../model/Organization";
import { campaignHttp } from "./campaign-http";
const cacheKeys = {
  campaigns: "campaigns",
  campaign: "campaign",
};

export const useGetCampaigns = (organizationKeyName?: OrganizationKeyName) => {
  return useQuery(
    [cacheKeys.campaigns, organizationKeyName],
    () => campaignHttp.getCampaigns(organizationKeyName),
    { refetchOnWindowFocus: false, enabled: !!organizationKeyName }
  );
};

export const useGetCampaign = (
  organizationKeyName?: OrganizationKeyName,
  id?: string
) => {
  return useQuery(
    [cacheKeys.campaign, id],
    () => campaignHttp.getCampaign(organizationKeyName, id),
    { refetchOnWindowFocus: false, enabled: !!id && !!organizationKeyName }
  );
};

export const useCreateCampaign = () => {
  const queryClient = useQueryClient();

  return useMutation(campaignHttp.createCampaign, {
    onSuccess: async () => {
      queryClient.refetchQueries([cacheKeys.campaigns]);
    },
  });
};

export const useDeleteCampaign = () => {
  const queryClient = useQueryClient();
  return useMutation(campaignHttp.deleteCampaign, {
    onSuccess: async () => {
      queryClient.refetchQueries([cacheKeys.campaigns]);
    },
  });
};

export const useUpdateCampaign = (id: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation(campaignHttp.updateCampaign, {
    onSuccess: async () => {
      queryClient.refetchQueries([cacheKeys.campaigns]);
      if (id) {
        queryClient.refetchQueries([cacheKeys.campaign, id]);
      }
    },
  });
};
